<template lang="pug">
q-dialog(:value="show", @hide="closeForm")
  q-card.filters-delete-form__card
    .row.justify-between
      .filters-delete-form__title
        span.filters-save-form__title__text {{ `${filterLocales.destroy_filter}?` }}

    .filters-delete-form__buttons-group
      button(type="secondary", :label="filterLocales.cancel", @click="closeForm")
      button(type="primary", :label="filterLocales.destroy", @click="onDelete")
</template>

<script setup>
import { ref, computed } from "vue";
import Button from "@/components/shared/general_components/inputs/Button.vue";
import backend from "@/api";
import { dynamicIssuesLocales } from "@/services/useLocales";

const props = defineProps({
  /* 
  Идентификатор фильтра
  */
  id: { type: String || Number, required: false, default: null },
  /* 
  Показатель видимости формы
  */
  show: { type: Boolean, required: true, default: false },
});

const emit = defineEmits([
  /* 
  При закрытии формы
  */
  "closeForm",
  /*
  При отправке формы, отправляет идентификатор фильтра
  */
  "delete",
]);

const filterLocales = computed(() => dynamicIssuesLocales.value.filters);

const closeForm = () => {
  emit("closeForm");
};

const onDelete = async () => {
  emit("delete", props.id);
};
</script>

<style lang="scss" scoped>
.filters-delete-form {
  &__card {
    border-radius: 20px !important;
    color: var(--expansion-list-text-color);
    background: var(--expansion-list-background);
    width: 350px;
    padding: 32px;
  }

  &__title {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    gap: 10px;
  }

  &__buttons-group {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
